import React from "react";

const Edit = () => {
  return (
    <div className="text-sm mb-2">
      <p>Mouse behavior when editing graphics:</p>
      <ul className="list-disc px-4 mt-2">
        <li>Select a graphic to activate the Edit toolbar.</li>
        <li>
          To move a graphic, once the Edit toolbar is activated with that
          graphic, press down on the graphic, drag it, then let go at the new
          location.
        </li>
        <li>
          To add a vertex to a polyline or polygon, click on a "ghost" vertices
          and move it to the new location.
        </li>
        <li>
          To delete a vertex from a polyline or polygon, right-click the vertex
          and select 'Delete Vertex' from the menu. Only valid for polylines
          with at least three vertices and polygons with at least four vertices.
        </li>
        <li>
          To rotate or scale a geometry click the handle and move to the desired
          location.
        </li>
        <li>
          Click on the map when finished editing to deactivate the Edit toolbar.
        </li>
      </ul>
    </div>
  );
};

export default Edit;
